export default "__VITE_ASSET__cBKKMmIV__"